var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Main"},[(_vm.loaded)?_c('div',[_c('table',{staticClass:"product-paramerets"},[_c('tbody',_vm._l((_vm.product_data),function(row){return _c('tr',{key:row.id},[_c('td',[_vm._v(_vm._s(row.title))]),_c('td',[_vm._v(_vm._s(row.desc))])])}),0)])]):_c('div',[_c('Loader')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109feffa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Params/Main.vue
// module id = null
// module chunks = 